export * from 'server/models/VesselServiceListing';


// WEBPACK FOOTER //
// ./data/models/VesselServiceListing.ts